import type { IAccountNotificationsPartnerPortal } from './AccountNotificationsPartnerPortal.interface';
import AccountNotificationsPreferences from './AccountNotificationsPreferences';

export default class AccountNotificationsPartnerPortal
  implements IAccountNotificationsPartnerPortal {
  partnerLoggedIn: AccountNotificationsPreferences;
  partnerUpdated: AccountNotificationsPreferences;

  static build = (data: IAccountNotificationsPartnerPortal) =>
    new AccountNotificationsPartnerPortal(data);

  static blank = () => new AccountNotificationsPartnerPortal();

  /**
   * Constructor
   * @param {IAccountNotificationsPartnerPortal} data
   */
  constructor(data?: IAccountNotificationsPartnerPortal) {
    this.partnerLoggedIn = new AccountNotificationsPreferences(data?.partnerLoggedIn);
    this.partnerUpdated = new AccountNotificationsPreferences(data?.partnerUpdated);
  }
}
